import { render } from "./Example1.vue?vue&type=template&id=32ede2d1"
import script from "./Example1.vue?vue&type=script&lang=ts"
export * from "./Example1.vue?vue&type=script&lang=ts"
script.render = render

export default script